import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const TrucksRoute = lazy(() => import("@/pages/trucks.page"));

export const Route = createFileRoute("/trucks")({
  component: TrucksRoute,
});
